export const ANALYTICS_CONSTANTS = {
  businessUnit: 'hospitality',
  platform: 'social-tables',
  product: 'authentication',
  component: 'st-earth-portal',
};
